import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { ensureArray } from '@epicuro-next/utilities';

export function indexIdsInObjectTree(
  dynamicItem: IDynamicItem,
  index: number | number[],
): void {
  const indexes = ensureArray(index);
  if (dynamicItem.id !== undefined) {
    const newId = `${dynamicItem.id}[${indexes.join('][')}]`;
    dynamicItem.id = newId;
  }

  if (dynamicItem.children !== undefined) {
    // A new index counter for each distinct id.
    const groupedById = groupById(dynamicItem.children);

    for (const children of Object.values(groupedById)) {
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        const newIndexes = [...indexes, i];
        indexIdsInObjectTree(child, newIndexes);
      }
    }
  }
}

function groupById(dynamicItems: IDynamicItem[]): {
  [id: string]: IDynamicItem[];
} {
  const groupedById: { [id: string]: IDynamicItem[] } = {};

  for (const dynamicItem of dynamicItems) {
    if (dynamicItem.id !== undefined) {
      if (groupedById[dynamicItem.id] === undefined) {
        groupedById[dynamicItem.id] = [];
      }
      groupedById[dynamicItem.id].push(dynamicItem);
    }
  }

  return groupedById;
}
